export default  {
  controller: 'messageController',
  template: require('../views/message.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/components/message.component.js